import React, { Component } from "react";
import { Segment } from "semantic-ui-react";
import SecondaryPrize from "../../components/forms/event/SecondaryPrize";

import request from "../../utils/request";

class EventAddPrize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: {
        id: 0,
        title: ""
      }
    }
  }
  componentDidMount = () => {
    this.getEvent();
  };
  getEvent = () => {
    return request
      .get(this, "api:/event", { eventId: this.props.eventId })
      .then(resp => {
        this.setState({ event: resp });
      });
  };
  render() {
    return (
      <Segment basic>
        <SecondaryPrize event={this.state.event} eventId={this.props.eventId} />
      </Segment>
    );
  }
}

export default EventAddPrize;
